import React, { useEffect, useRef } from 'react'
import Modal from '@/v2/components/common/Modal'
import CreateContractForm from './CreateContractForm/CreateContractForm'
import { useCreateContractState } from './CreateContractStateContext/CreateContractStateContext'
import ContractConfirm from './ContractConfirm'

const CreateContractModal = ({ isOpen, patientId, email, onClose }) => {
  const [state, setState] = useCreateContractState()
  const sessionKeyRef = useRef(Date.now())
  const wasOpenRef = useRef(false)

  useEffect(() => {
    if (isOpen && !wasOpenRef.current) {
      sessionKeyRef.current = Date.now()
      wasOpenRef.current = true
    } else if (!isOpen) {
      wasOpenRef.current = false
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create Contract"
      footer={<></>}
      disableBackdropClick
      fullWidth
      maxWidth="xs"
    >
      {state.step === 1 ? (
        <CreateContractForm
          patientId={patientId}
          state={state}
          setState={setState}
          onClose={onClose}
        />
      ) : (
        <ContractConfirm
          patientId={patientId}
          email={email}
          onClose={onClose}
          state={state}
          setState={setState}
        />
      )}
    </Modal>
  )
}

export default CreateContractModal
